import { render, staticRenderFns } from "./TeamTailorIcon.vue?vue&type=template&id=15c4c57a&scoped=true&"
import script from "./TeamTailorIcon.vue?vue&type=script&lang=ts&"
export * from "./TeamTailorIcon.vue?vue&type=script&lang=ts&"
import style0 from "./TeamTailorIcon.vue?vue&type=style&index=0&id=15c4c57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c4c57a",
  null
  
)

/* custom blocks */
import block0 from "./TeamTailorIcon.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports